import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent, sendScreenEvent } from 'services/analytics';

const trackViewAllBadgesClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: SCREEN_NAME.PROFILE,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'viewAllBadges',
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71746
const trackBadgesBackToProfileClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: SCREEN_NAME.BADGES,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'backToProfile',
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71732
const trackBadgesScreenView = (isPersonalView: boolean) => {
  sendScreenEvent({
    screenName: SCREEN_NAME.BADGES,
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71855
const trackEmptyStartLearningClick = (isPersonalView: boolean) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'coursesStartLearning',
    source: SCREEN_NAME.PROFILE,
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/85447
const trackEmptyBadgeVisitForumsClick = (isPersonalView: boolean) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'unifiedProfileBadgesVisitForums',
    source: SCREEN_NAME.PROFILE,
    isPersonalView,
  });
};

export {
  trackViewAllBadgesClick,
  trackBadgesBackToProfileClick,
  trackBadgesScreenView,
  trackEmptyStartLearningClick,
  trackEmptyBadgeVisitForumsClick,
};
